<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4.10854 17.9039L8.98021 13.0323C9.3346 13.1273 9.71044 13.1027 10.0494 12.9623C10.3884 12.8219 10.6716 12.5736 10.8551 12.2558C11.0385 11.9381 11.112 11.5687 11.0641 11.2049C11.0162 10.8412 10.8497 10.5034 10.5902 10.2439C10.3308 9.98447 9.99299 9.81789 9.62922 9.77001C9.26546 9.72213 8.89606 9.79562 8.57832 9.97909C8.26058 10.1626 8.01226 10.4457 7.87187 10.7847C7.73149 11.1237 7.70688 11.4995 7.80187 11.8539L2.93021 16.7256L2.04688 15.8423C4.40271 13.0923 5.28687 10.0473 6.46521 4.9406L11.7685 4.35143L16.4827 9.0656L15.8935 14.3689C10.7869 15.5473 7.74187 16.4314 4.99271 18.7881L4.10854 17.9048V17.9039ZM13.831 1.69976L19.1202 6.9881C19.1747 7.04251 19.2131 7.11096 19.231 7.18585C19.249 7.26074 19.2458 7.33914 19.2219 7.41235C19.198 7.48555 19.1543 7.5507 19.0956 7.60055C19.0369 7.65041 18.9655 7.68302 18.8894 7.69476L17.661 7.88643L12.9477 3.1731L13.1244 1.9356C13.1354 1.85907 13.1674 1.78711 13.217 1.72777C13.2665 1.66842 13.3316 1.62403 13.4049 1.59955C13.4782 1.57508 13.5569 1.57149 13.6322 1.58919C13.7075 1.60689 13.7763 1.64517 13.831 1.69976Z" :fill="color ? color:'#040410'" />
  </svg>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconOffer',
  components: {}
})
export default class extends Vue {
  @Prop({ default: '#040410' }) private color!: String
  @Prop({ default: '20' }) width!: string
  @Prop({ default: '20' }) height!: string
}
</script>

<style scoped>
</style>
